var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Body } from '../../root/PageRouter';
import { useRouter } from '../../../context/router-context';
import { SafeDetails } from './Safe';
import { Card } from '../../common/card';
import { Button } from '../../common/button';
import { AlertDialog } from '../../common/alert-dialog';
import { refetchSafesListQuery, useDeleteSafeCertificateMutation, useIssueSafeCertificateMutation, } from '../../../__generated__/graphql';
export default function DraftSafe(props) {
    var _this = this;
    // Router
    var goBack = useRouter().goBack;
    // State
    var _a = useState(false), deleteDialogIsOpen = _a[0], setDeleteDialogIsOpen = _a[1];
    var _b = useState(false), issueDialogIsOpen = _b[0], setIssueDialogIsOpen = _b[1];
    // GraphQL mutation
    var deleteSafe = useDeleteSafeCertificateMutation({
        variables: { input: { safeId: props.safe.id } },
        refetchQueries: [
            refetchSafesListQuery({ organizationId: props.organizationId }),
        ],
    })[0];
    var issueSafe = useIssueSafeCertificateMutation({
        variables: { input: { safeId: props.safe.id } },
    })[0];
    // Event handlers Delete
    var openDeleteDialog = function () {
        setDeleteDialogIsOpen(true);
    };
    var closeDeleteDialog = function () {
        setDeleteDialogIsOpen(false);
    };
    var confirmDeleteSafe = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = deleteSafe();
                    goBack();
                    setDeleteDialogIsOpen(false);
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Event handlers Issue
    var openIssueDialog = function () {
        setIssueDialogIsOpen(true);
    };
    var closeIssueDialog = function () {
        setIssueDialogIsOpen(false);
    };
    var confirmIssueSafe = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = issueSafe();
                    setIssueDialogIsOpen(false);
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog, { "data-test": "issue-safe-dialog", isOpen: issueDialogIsOpen, title: "Issue this SAFE?", content: "The state will be changed to issued, and the SAFE will no longer be editable.", onBackdropClick: closeIssueDialog, buttons: [
                    {
                        label: 'Confirm',
                        primary: true,
                        onClick: confirmIssueSafe,
                    },
                    {
                        label: 'Keep as draft',
                        onClick: closeIssueDialog,
                    },
                ] }, void 0),
            _jsx(AlertDialog, { "data-test": "delete-safe-dialog", isOpen: deleteDialogIsOpen, title: "Delete this SAFE?", content: "This action cannot be undone.", onBackdropClick: closeDeleteDialog, buttons: [
                    {
                        label: 'Delete',
                        primary: true,
                        onClick: confirmDeleteSafe,
                    },
                    {
                        label: 'Cancel',
                        onClick: closeDeleteDialog,
                    },
                ] }, void 0),
            _jsx(Body, { children: _jsxs(Card, { children: [_jsx(SafeDetails, { safe: props.safe }, void 0),
                        _jsx(Button, __assign({ "data-test": "open-issue-dialog-button", onClick: openIssueDialog }, { children: "Issue" }), void 0),
                        _jsx(Button, __assign({ "data-test": "open-delete-dialog-button", onClick: openDeleteDialog }, { children: "Delete" }), void 0)] }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=DraftSafe.js.map